import { render, staticRenderFns } from "./ValuesMethodology.vue?vue&type=template&id=9612990c&"
import script from "./ValuesMethodology.vue?vue&type=script&lang=js&"
export * from "./ValuesMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports